(function() {
    const $CARD = '.catalog-card',
          $CARD_FEATURE = '.card-feature',
          $RADIO_ALL = '.form-check label input[type="radio"]',
          $DROPDOWN_FILTER = '.accordion-button-filter',
          $CHECKBOX_ALL = '.form-check label input[type="checkbox"]',
          $CHECKBOX_ALL_MINUS_SECONDARY = '.form-check label:not(.secondary) input[type="checkbox"]',
          $CHECKBOX_NEST = '.form-check.form-check-nest',
          $CHECKBOX_PRIMARY = '.form-check label.primary input[type="checkbox"]',
          $CHECKBOX_SECONDARY = '.form-check label.secondary input[type="checkbox"]',
          $TAG_FILTER = '.tag-filter',
          $TAG_STRUCTURE = '<button class="btn tag-filter bg-secondary text-white me-2 mb-2 px-2 py-1 rounded-0 light" data-category="$CATEGORY" value="$VALUE"><div class="d-flex">$TITLE <span class="btn-close btn-close-white ms-2 ps-2 pe-none"></span></div></button>',
          $STOCK_INDICATOR_STRUCTURE = `<a href="[product_url]?sku=[sku]" data-sku="[sku]" class="px-2 mt-1 me-1 order-[size_order_index]" data-availability="[availability]" data-bs-content="[copy]" data-bs-custom-class="popover-stock [availability]" aria-label="[copy]" aria-hidden="true" data-bs-html="true" data-bs-placement="top" data-bs-toggle="popover" data-bs-trigger="hover focus" dl_select_item>[title]</a>`;

    const catalog_container = document.querySelector('#collections_all'),
          card_feature_default = document.querySelectorAll('.card-feature.default'),
          card_objs = catalog_container.querySelectorAll($CARD),
          card_merged = catalog_container.querySelectorAll('.catalog-card[data-sku-handle]'),
          card_button_sort = catalog_container.querySelectorAll('[data-catalog-sort]'),
          checkbox_all = catalog_container.querySelectorAll($CHECKBOX_ALL),
          tag_container = catalog_container.querySelector('.tag-container'),
          filter_clear = catalog_container.querySelectorAll('.filter-clear'),
          filter_summary_count = catalog_container.querySelectorAll('.filter-count'),
          accordion_collapsible = document.querySelectorAll('.accordion-collapse[data-bs-parent="#collections_all"]'),
          datalayer_track_item_target = document.querySelectorAll('[dl_track_item]');

    const observer_datalayer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                observer_datalayer.unobserve(entry.target);
                datalayer_event('observe_item', entry);
            }
        });
    }, { threshold: 1 });

    let catalog_nav_isDragging = false,
        map_order_price_raw = {},
        map_url_param = { 'availability': [], 'collection': [], 'size': [], 'upholstery': [], 'color': [], 'design': [], 'sort': [] };

    function show_sale_card_when_no_or_more_than_one_query_parameter () {
        const url = new URL(window.location.href);
        const has_search_params = Array.from(url.searchParams.keys()).length > 0;
        const onsale_filter_is_on = url.searchParams.get('availability') === 'onsale';

        if (!has_search_params || onsale_filter_is_on) {
            card_feature_default.forEach((card, index) => {
                let matched;
                if (url.searchParams.get('collection')) {
                    matched = card.getAttribute('data-collection') === url.searchParams.get('collection');
                } else {
                    matched = index === 0;
                }
                card.classList[matched ? 'add' : 'remove']('show');
            });
        }
    }

    window.collection_grid = class collection_grid {
        constructor() {
            // Initialize DOM content
            this.init();

            // Bind events
            this.bind_event();

            // Initialize DOM state
            collection_grid.update('filter_results');
            collection_grid.update('filter_sort');
            collection_grid.update('button_tag');
            collection_grid.update('button_product');
        }

        static debug(type) {
            let list = [];

            type = type || 'newest',
            type = type.match(/(newest|best-sellers)/) ? type : 'newest';

            card_objs.forEach(element => {
                let product_sku = element.getAttribute('data-sku'),
                    product_index = type == 'best-sellers' ? map_order.bestsellers.indexOf(product_sku) : map_order.newest.indexOf(product_sku);
                if (product_index == -1) { list.push(product_sku); }
            });

            return type + ': ' + list;
        }

        static update(action, object) {
            switch(action){
                case 'filter_clear':
                    let element = object;

                    if (element == null) {
                        map_url_param.availability = map_url_param.collection = map_url_param.size = map_url_param.upholstery = map_url_param.color = map_url_param.design = [];

                        checkbox_all.forEach(element => {
                            element.indeterminate = false;
                            element.checked = false;
                        });

                        catalog_container.querySelectorAll($TAG_FILTER).forEach(element => {
                            element.remove();
                        });
                    } else {
                        let category = element.getAttribute('data-category'),
                            value = element.value,
                            checkbox = catalog_container.querySelector($CHECKBOX_ALL + '[data-category="' + category + '"][value="' + value + '"]'),
                            checkbox_isPrimary = checkbox.parentElement.classList.contains('primary');

                        map_url_param[category] = map_url_param[category].filter(obj => { return obj != value });
                        checkbox.checked = false;
                        element.remove();

                        collection_grid.update('checkbox_nested', checkbox_isPrimary);
                    }

                    document.querySelectorAll($CARD_FEATURE).forEach(element => {
                        element.classList.remove('show');
                    });

                    collection_grid.update('url');
                    collection_grid.update('filter_results');
                    collection_grid.update('button_product');

                    show_sale_card_when_no_or_more_than_one_query_parameter();

                    break;
                case 'filter_results':
                    let filter_onsale = false,
                        filter_free_return = false,
                        filter_count = map_url_param.availability.length + map_url_param.collection.length + map_url_param.size.length + map_url_param.upholstery.length + map_url_param.color.length + map_url_param.design.length,
                        array_cards = Array.from(card_objs),
                        card_filtered_shown = array_cards.map(element =>
                            ({
                                element: element,
                                availability: element.getAttribute('data-availability'),
                                collection: element.getAttribute('data-collection'),
                                size: element.getAttribute('data-size'),
                                upholstery: element.getAttribute('data-upholstery'),
                                color: element.getAttribute('data-color'),
                                design: element.getAttribute('data-design')
                            })
                        ),
                        card_filtered_hidden = [];

                    for (let key in map_url_param) {
                        let dropdown_filter = catalog_container.querySelector($DROPDOWN_FILTER + '[data-category="' + key + '"]');
                        if ( dropdown_filter == null ) { continue; }
                        if ( !map_url_param[key].length || key == 'sort' ) {
                            dropdown_filter.classList.remove('active');
                            continue;
                        }
                        dropdown_filter.classList.add('active');

                        let selector = '',
                            attributes = map_url_param[key].toString().split(',');
                        attributes.forEach(attribute => {
                            if ( filter_count == 1 ) {
                                let card_feature = document.querySelector($CARD_FEATURE + '[data-category="' + key + '"][data-selection*="' + attribute + '"]');
                                if ( card_feature ) {
                                 
                                    card_feature.style.display = null;
                                    card_feature.classList.add('show');
                                }
                            }
                            if ( key == 'availability' && attribute == 'onsale' ) {
                                filter_onsale = true;
                                return;
                            }
                            if ( key == 'availability' && attribute == 'freereturn' ) {
                                filter_free_return = true;
                                return;
                            }

                            selector += (selector == '' ? '' : '|') + (attribute == 'xl' ? '(?<!-)' : '') + attribute;
                        });
                        if ( JSON.stringify(attributes) === JSON.stringify(['cable-management', 'desk-others'])) {
                            let card_feature = document.querySelector($CARD_FEATURE + '[data-category="' + key + '"][data-selection*="desk-addons"]');
                            if ( card_feature ) {
                                card_feature.style.display = null;
                                card_feature.classList.add('show');
                            }
                        }
                        let filter_regex = new RegExp('(' + selector + ')');
                        card_filtered_hidden = card_filtered_hidden.concat(card_filtered_shown.filter(element => !element[key].toString().match(filter_regex)));
                        card_filtered_shown = card_filtered_shown.filter(element => element[key].toString().match(filter_regex));
                    }

                    if (filter_onsale) {
                        card_filtered_hidden = card_filtered_hidden.concat(card_filtered_shown.filter(element => !element['availability'].toString().match(/(onsale)/)));
                        card_filtered_shown = card_filtered_shown.filter(element => element['availability'].toString().match(/(onsale)/));
                        show_sale_card_when_no_or_more_than_one_query_parameter();

                    }
                    if (filter_free_return) {
                        card_filtered_hidden = card_filtered_hidden.concat(card_filtered_shown.filter(element => !element['availability'].toString().match(/(freereturn)/)));
                        card_filtered_shown = card_filtered_shown.filter(element => element['availability'].toString().match(/(freereturn)/));
                    }

                    card_filtered_hidden.forEach(object => object.element.style.display = 'none' );
                    card_filtered_shown.forEach(object => object.element.style.display = null );

                    filter_summary_count.forEach(element => {
                        element.innerHTML = card_filtered_shown.length;
                    });

                    if ( card_filtered_shown.length == 0 ) {
                        document.querySelectorAll($CARD_FEATURE).forEach(element => {
                            element.style.display = 'none';
                        });

                        catalog_container.setAttribute('data-state', 'noresult');
                    } else if ( card_filtered_hidden.length == 0) {
                        catalog_container.setAttribute('data-state', 'showall');
                    } else {
                        catalog_container.setAttribute('data-state', 'filtered');
                    }


                    break;
                case 'filter_sort':
                    let type = object,
                        current_checked = catalog_container.querySelector('.form-check label input[type="radio"]:checked');
                        current_checked = current_checked ? current_checked.getAttribute('data-catalog-sort') : null;
                        type = type == undefined ? current_checked || 'featured' : type;

                    card_button_sort.forEach(element => {
                        if ( element.getAttribute('data-catalog-sort') == type ) {
                            element.checked = true;
                            return;
                        }
                    });

                    card_objs.forEach(element => {
                        let product_sku = element.getAttribute('data-sku'),
                            product_order = map_order.bestsellers.indexOf(product_sku) + 5, // type == best-sellers; Base for other types.
                            product_order_new = map_order.newest.indexOf(product_sku) === -1 ? 60 : map_order.newest.indexOf(product_sku),
                            product_isAvailable = !element.getAttribute('data-availability').match(/(out-of-stock|not-available|coming-soon)/);

                        if ( type == 'new' ) { product_order = product_order_new + 5; }
                        if ( type == 'price-lowest' ) { product_order = map_order.price.length - map_order.price.indexOf(product_sku) + 5; }
                        if ( type == 'price-highest' ) { product_order = map_order.price.indexOf(product_sku) + 5; }

                        if ( !product_isAvailable ) { product_order += 9999; } // If product is not available, set sorting order to the very bottom.
                        if ( product_order == 4 ) { product_order = 9000; } // Fallback if no order can be assigned, and product does not exist in bestsellers array.

                        // Update dataarray_variable.product_data.sku.position with sorting order
                        dataarray_variable.product_data.find((array) => {
                            if ( array.id === product_sku ) {
                                array.position = product_order;
                            }
                        })

                        // Set element flex order
                        element.style.order = product_order;
                    });

                    // Sanitize dataarray_variable.product_data data, before firing datalayer event
                    // Sort by accending array.position (from 24, 5, 1, 3 ... to 1, 2, 5, 24)
                    // Then redefine array.position as index (from 1, 2, 5, 24 ... to 1, 2, 3, 4 ...)
                    dataarray_variable.product_data.sort(function(a,b) { return a.position - b.position; });
                    dataarray_variable.product_data.forEach((array, index) => { array.position = index + 1; });

                    map_url_param['sort'] = type == 'featured' ? [] : [type];

                    break;
                case 'url':
                    const tr_urlQuery = window.location.search;
                    const tr_urlParams = new URLSearchParams(tr_urlQuery);

                    const refersion_param = ['rfsn', 'utm_source', 'utm_medium', 'utm_campaign'];
                    let paramURL = '';
                    for (let key in map_url_param) {
                        if ( !map_url_param[key].length ) { continue; }
                        paramURL += (paramURL == '' ? '?' : '&') + key + '=' + map_url_param[key].join(',');
                    }

                    for (let key in refersion_param) {
                        if (tr_urlParams.get(refersion_param[key]) === null || tr_urlParams.get(refersion_param[key]) === 'null') { continue; }
                        paramURL += (paramURL == '' ? '?' : '&') + refersion_param[key] + '=' + tr_urlParams.get(refersion_param[key]);
                    }

                    window.history.replaceState(null, null, window.location.origin + window.location.pathname + paramURL);
                    show_sale_card_when_no_or_more_than_one_query_parameter();

                    break;
                case 'button_tag':
                    catalog_container.querySelectorAll($TAG_FILTER).forEach(element => {
                        element.remove();
                    });

                    let new_tags = document.createElement('template');
                    for (let key in map_url_param) {
                        if ( key == 'sort' ) { continue; }
                        map_url_param[key].forEach(attribute => {
                            let element = catalog_container.querySelector($CHECKBOX_ALL + '[data-category="' + key + '"][value="' + attribute + '"]');
                            if (element == null) { return; }

                            let title = element.getAttribute('data-title'),
                                tag = document.createElement('template');
                            tag.innerHTML = $TAG_STRUCTURE.replace('$CATEGORY', key).replace('$VALUE', attribute).replace('$TITLE', title),
                            tag = tag.content.firstChild;

                            tag.addEventListener('click', () => {
                                collection_grid.update('filter_clear', tag);
                            });

                            new_tags.content.append(tag);
                        });
                    }
                    tag_container.prepend(new_tags.content);

                    break;
                case 'checkbox_nested':
                    catalog_container.querySelectorAll($CHECKBOX_NEST).forEach(element => {
                        let primary = element.querySelector($CHECKBOX_PRIMARY),
                            secondary = element.querySelectorAll($CHECKBOX_SECONDARY),
                            is_all_checked = 0,
                            is_indeterminate = false;

                        if ( primary.checked ) {
                            secondary.forEach(element => {
                                element.checked = true;
                            })
                            primary.indeterminate = false;

                            return;
                        }

                        secondary.forEach(element => {
                            if ( object == true ) {
                                element.checked = false;
                            } else if ( element.checked ) {
                                is_all_checked += 1;
                                is_indeterminate = true;
                            }
                        });

                        primary.indeterminate = is_indeterminate;
                    });
            }
        }

        bind_event() {
            datalayer_track_item_target.forEach(element => {
                // Datalayer event: dl_select_item
                element.addEventListener('click', event => { datalayer_event('select_item', event) });

                // Datalayer event: dl_observe_item
                if ( element.classList.contains($CARD.replace(/./, '')) ) {
                    observer_datalayer.observe(element)
                }
            });

            // Filter sorting
            card_button_sort.forEach(element => {
                element.addEventListener('change', event => {
                    collection_grid.update('filter_sort',  event.target.getAttribute('data-catalog-sort') );
                    collection_grid.update('url');
                });
            });

            // Filter checkbox
            checkbox_all.forEach(element => {
                let checkbox_nest = element.closest('.form-check-nest'),
                    checkbox_isPrimary = element.parentElement.matches('.primary'),
                    checkbox_isSecondary = element.parentElement.matches('.secondary'),
                    checkbox_primary = checkbox_nest ? checkbox_nest.querySelector($CHECKBOX_PRIMARY) : null,
                    checkbox_secondary = checkbox_nest ? element.closest('.form-check').querySelectorAll($CHECKBOX_SECONDARY) : null;

                if ( checkbox_isPrimary ) {
                    element.addEventListener('change', event => {
                        let checkbox_state = element.checked;

                        checkbox_secondary.forEach(element => {
                            element.checked = checkbox_state;
                        });
                    });
                }

                if ( checkbox_isSecondary ) {
                    element.addEventListener('change', event => {
                        let checkbox_children_count = checkbox_nest.querySelectorAll($CHECKBOX_SECONDARY).length,
                            checkbox_children_checked = checkbox_nest.querySelectorAll($CHECKBOX_SECONDARY + ':checked').length;

                        checkbox_primary.checked = checkbox_children_count == checkbox_children_checked;
                        checkbox_primary.indeterminate = checkbox_children_checked > 0 && checkbox_children_checked < checkbox_children_count;
                    });
                }

                element.addEventListener('change', event => {
                    let paramArray = { 'availability': [], 'collection': [], 'size': [], 'upholstery': [], 'color': [], 'design': [] },
                        checkbox_notsecondary_checked = catalog_container.querySelectorAll($CHECKBOX_ALL_MINUS_SECONDARY + ':checked'),
                        checkbox_secondary_checked = catalog_container.querySelectorAll($CHECKBOX_SECONDARY + ':checked');

                    checkbox_notsecondary_checked.forEach(element => {
                        let checkbox_category = element.getAttribute('data-category'),
                            checkbox_value = element.value;

                        paramArray[checkbox_category].push(checkbox_value);
                    });
                    checkbox_secondary_checked.forEach(element => {
                        let checkbox_nest = element.closest('.form-check-nest'),
                            checkbox_primary = checkbox_nest.querySelector($CHECKBOX_PRIMARY),
                            checkbox_category = element.getAttribute('data-category'),
                            checkbox_value = element.value;

                        if ( checkbox_primary.checked ) { return; }

                        paramArray[checkbox_category].push(checkbox_value);
                    });

                    for (let key in paramArray) {
                        map_url_param[key] = paramArray[key];
                    }

                    document.querySelectorAll($CARD_FEATURE).forEach(element => {
                        element.classList.remove('show');
                    });

                    collection_grid.update('filter_results');
                    collection_grid.update('url');
                    collection_grid.update('button_tag');
                    collection_grid.update('button_product');
                });
            });

            // Filter clear
            filter_clear.forEach(element => {
                element.addEventListener('click', () => {
                    collection_grid.update('filter_clear');
                });
            });

            // Temporary solution to bootstrap bug - https://github.com/twbs/bootstrap/issues/35685
            accordion_collapsible.forEach(element => {
                element.addEventListener('show.bs.collapse', event => { catalog_container.classList.add('accordion-isTransitioning'); });
                element.addEventListener('shown.bs.collapse', event => { catalog_container.classList.remove('accordion-isTransitioning'); });
            });

            // Accordion auto close
            document.addEventListener('click', event => {
                let accordion_button_active = document.querySelector('.accordion-button-filter[aria-expanded="true"]');
                if ( window.innerWidth >= 992 && accordion_button_active != null ) {
                    if ( event.target.closest('.accordion-button-filter[aria-expanded="true"], .accordion-collapse-content') == null ) {
                        accordion_button_active.click();
                    }
                }
            });
        }
        init() {
            function add_product_color_options() {

                const product_with_color_variant_options =  {};
                const withColorHandle =  catalog_container.querySelectorAll('.catalog-card[data-color-handle]');
                withColorHandle.forEach(element => {
                    const colorHandle = element.getAttribute("data-color-handle");
                    if(!product_with_color_variant_options[colorHandle]) {
                        product_with_color_variant_options[colorHandle] = [];
                    }
                     product_with_color_variant_options[colorHandle].push(element);
                });

                Object.entries(product_with_color_variant_options).forEach(([key, productCards]) => {
                    productCards.forEach(card => {
                        const card_variants_color_options = card.querySelector('.variant-color-options');
                        let innerHTML = "";
                        let printedColors = [];
                
                        productCards.forEach(colorOptions => {
                            const dataSku = colorOptions.getAttribute('data-sku-new')?.split('-');
                            const variantColorClass = dataSku?.[dataSku?.length - 1]?.toLowerCase();
                            if(printedColors.indexOf(variantColorClass) !== -1){
                                return;
                            }
                            innerHTML += `<div class="swatch rounded-circle ${variantColorClass}"></div>`;
                            printedColors.push(variantColorClass);
                        });

                        card_variants_color_options.innerHTML = innerHTML;
                    });
                });

            }
            // Populate data of merged cards
            function init_card_data() {
                card_merged.forEach(card => {
                    let card_stocks = card.querySelector('.card-info-bottom'),
                        card_pricing_container = card.querySelector('.card-pricing'),
                        sale_size_info = card.querySelector('.sale-available-info'),
                        freeEligibleText = card.querySelector('.free-eligible-text'),
                        card_oos_container = card.querySelector('.card-oos'),
                        card_price_direct = card.querySelector('.price-direct'),
                        card_price_shopify = card.querySelector('.price-shopify'),
                        card_price_from = card.querySelector('.price-from'),
                        card_price_savings = card.querySelector('.price-savings'),
                        card_savings = card.querySelector('.savings'),
                        product_url = card.getAttribute('href'),
                        product_availability = 'out-of-stock',
                        product_onsale = false,
                        product_sizes = [],
                        product_price_shopify = [],
                        product_price_direct = [],
                        product_price_msrp = [],
                        collection_handle = card.getAttribute('data-pseudo-collection'),
                        data_sku = card.getAttribute('data-sku'),
                        data_sku_new = card.getAttribute('data-sku-new'),
                        sku_handle = card.getAttribute('data-sku-handle'),
                        sku_new_handle = card.getAttribute('data-sku-new-handle'),
                        data_price_direct = card.getAttribute('data-price-direct'),
                        product_info_raw = card_info_raw[collection_handle],
                        isEligibleFreeReturn = card.getAttribute('is-eligible-free-return-product');
                    if ( product_info_raw == undefined ) { return; }
                    let info_keys = Object.keys(product_info_raw).filter(key => {
                        if ( collection_handle == 'magnus-pro' && sku_handle == '' ) {
                            return key.match(/^MPB2-(15|17)(B|F|I|G)$/);
                        }

                        const result = `${key} `.toLowerCase().includes(`${sku_handle} `.toLowerCase()) || `${key}`.toLowerCase().includes(`${sku_new_handle}`.toLowerCase());
                        if(!result && collection_handle == 'skins' && `${key}`.toLowerCase().indexOf('24s6') > -1) {
                            const oldKey = `${key}`.replace('24S6', '24S');
                            return `${oldKey} `.toLowerCase().includes(`${sku_handle} `.toLowerCase()) || `${oldKey}`.toLowerCase().includes(`${sku_new_handle}`.toLowerCase());
                        }
                        if(result && collection_handle == 'magnus-pro') {
                            const isKeyBlack = `${key}`.toUpperCase().indexOf('MPB2-B') > -1 || `${key}`.toUpperCase().indexOf('MPB2-1') > -1
                            let isCardBlack = false;
                            if(`${data_sku}`.toUpperCase().indexOf('MPB2-B') > -1 ||
                                `${data_sku_new}`.toUpperCase().indexOf('MPB2-B') > -1 ||
                                `${data_sku}`.toUpperCase().indexOf('MPB2-1') > -1 ||
                                `${data_sku_new}`.toUpperCase().indexOf('MPB2-1') > -1
                            ) {
                                isCardBlack = true;
                            }
                            if(isCardBlack === isKeyBlack) {
                                return true;
                            }
                            return false;
                        }
                        return result;
                    });

                    if ( info_keys.length == 1 && !info_keys[0].match(/(SKS22|SKR22|SKX22|S22|R22|XL22|REL|XEL|M06|M07|M08|SKS24|SKR24|X24S)/) ) {
                        let key_obj = card_info_raw[collection_handle][info_keys[0]],
                            product_copy = key_obj.copy.split('<br>')[1];

                        product_availability = key_obj.availability;
                        product_price_shopify = [key_obj.price_shopify];
                        product_price_direct = [key_obj.price_direct];
                        product_price_msrp = [key_obj.price_msrp];
                        product_onsale = key_obj.price_shopify < key_obj.price_direct ? true : false;

                        if (product_availability == 'pre-order' && product_copy) {
                            card_stocks.innerHTML = product_copy;
                        }
                    } else {
                        const saleSizeList = [];
                        info_keys.forEach(key => {
                    
                            let key_obj = card_info_raw[collection_handle][key],
                                variant_price_shopify = key_obj.price_shopify,
                                variant_price_direct = key_obj.price_direct,
                                variant_price_msrp = key_obj.price_msrp,
                                variant_title = key_obj.title,
                                variant_copy = key_obj.copy,
                                sale_available_info = key_obj.sale_available_info,
                                variant_availability = key_obj.availability,
                                variant_size = key.match(/SKS22|S22|M06|SKS24/) ? 'small' : key.match(/SKR22|R22|M07|SKR24|X24S/) ? 'regular' : 'xl';
                                if(collection_handle == 'titan-evo-lite'){
                                    variant_size = key.match(/REL/) ? 'regular' : 'xl';
                                }

                            if (sale_available_info){ 
                                saleSizeList.push(sale_available_info);
                            }
                            
                            product_availability = variant_availability != 'out-of-stock' ? variant_availability : product_availability;
                            let size_order_index = "0";
                            if(variant_size == 'regular'){
                                size_order_index = "1";
                            }else if(variant_size == 'xl'){
                                size_order_index = "2";
                            }
                            product_sizes.push(variant_size);
                            product_price_shopify.push(variant_price_shopify);
                            product_price_direct.push(variant_price_direct);
                            product_price_msrp.push(variant_price_msrp);
                            product_onsale = key_obj.price_shopify < key_obj.price_direct ? true : product_onsale;

                            // Variant specific sale and availability
                            const isVariantSale = variant_price_shopify < variant_price_direct;
                            const variantAvailability = isVariantSale ? 'on-sale' : variant_availability

                            card_stocks.innerHTML = card_stocks.innerHTML + $STOCK_INDICATOR_STRUCTURE
                              .replace('[product_url]', product_url)
                              .replace(/\[sku\]/g, key)
                              .replace(/\[availability\]/g, variantAvailability)
                              .replace(/\[copy\]/g, variant_copy)
                              .replace('[title]', variant_title)
                              .replace('[size_order_index]', size_order_index);
                        });
                        
                        if(saleSizeList?.length > 0 && sale_size_info){
                            try {
                                sale_size_info.innerHTML = `${getAvailableSizeTextBySaleSize(saleSizeList, product_sizes)}`;
                            } catch (error) {
                                console.log("error", error);
                            }
                        }

                    }
                    let product_discount = [];
                    product_price_shopify.forEach((price, index) => product_discount.push(parseInt(product_price_msrp[index]) - parseInt(price)));
                    const lowest_price_index = product_price_shopify.indexOf(Math.min(...product_price_shopify))
                    if( product_price_direct[lowest_price_index] > product_price_shopify[lowest_price_index] && collection_handle != 'magnus-pro'){
                        card_price_direct.innerHTML = currency_symbol + thousand_sep(product_price_direct[lowest_price_index]);
                    }
                    if( collection_handle == 'magnus-pro'){
                        card_price_direct.innerHTML = currency_symbol + thousand_sep(data_price_direct);
                    }

                    product_price_shopify = product_price_shopify.filter((value, index, self) => { return self.indexOf(value) === index; }).sort((a, b) => { return a - b });
                    product_price_direct = product_price_direct.filter((value, index, self) => { return self.indexOf(value) === index; }).sort((a, b) => { return a - b });
                    product_discount = product_discount.filter((value, index, self) => { return self.indexOf(value) === index; }).sort((a, b) => { return b - a });
                    
                   
                    
                    card.setAttribute('data-size', product_sizes.join(','));
                    const isProductOnSaleAndOneSize = product_onsale && product_sizes.length === 1;
                    card.setAttribute('data-availability', (product_onsale ? 'onsale,' : '') + (isEligibleFreeReturn =='true' && !isProductOnSaleAndOneSize ? 'freereturn,': '') + product_availability);
                    if(isProductOnSaleAndOneSize) {
                        freeEligibleText.remove();
                    }
                    if ( product_availability == 'out-of-stock' ) {
                        card_oos_container.style.display = null;
                        card_price_direct.style.display = 'none';
                        card_pricing_container.style.display = 'none';
                        return;
                    }

                    card.setAttribute('data-price', product_price_shopify[0]);
                    card_price_shopify.innerHTML = currency_symbol + thousand_sep(product_price_shopify[0]);
                    if (card_savings) {
                        const savings = product_discount[0];
                        if (savings > 0) {
                            // card_savings.innerHTML = savings;
                        } else {
                            card_price_savings.remove()
                        }
                    }
                    if ( parseInt(product_price_shopify[0]) < parseInt(product_price_direct[0]) ) {
                        // card_price_direct.innerHTML = currency_symbol + thousand_sep(product_price_direct[0]);
                    }
                    if ( product_price_shopify.length == 1 ) {
                        card_price_from.style.display = 'none';
                    }
                });
            }

            // Populate price list for sorting purposes
            function init_price_list() {
                card_objs.forEach(element => {
                    let product_price = element.getAttribute('data-price'),
                        product_sku = element.getAttribute('data-sku');

                    if ( product_price == null ) { return; }
                    map_order_price_raw[product_sku] = product_price;
                });
                map_order.price = Object.keys(map_order_price_raw).sort((a, b) => { return map_order_price_raw[b] - map_order_price_raw[a] });
            }

            // If there is URL PARAM, Initialize checkbox/sort option values
            function init_url_param() {
                let urlQuery = window.location.search;

                let urlParams = new URLSearchParams(urlQuery),
                    help_param = document.querySelector('[data-help-target="' + urlParams.get('help') + '"]');

                map_url_param = {
                        'availability': urlParams.get('availability') ? urlParams.get('availability').split(',') : [],
                        'collection': urlParams.get('collection') ? urlParams.get('collection').split(',') : [],
                        'size': urlParams.get('size') ? urlParams.get('size').split(',') : [],
                        'upholstery': urlParams.get('upholstery') ? urlParams.get('upholstery').split(',') : [],
                        'color': urlParams.get('color') ? urlParams.get('color').split(',') : [],
                        'design': urlParams.get('design') ? urlParams.get('design').split(',') : [],
                        'sort': urlParams.get('sort') ? urlParams.get('sort').split(',') : []
                };

                let element_sort = catalog_container.querySelector($RADIO_ALL + '[data-catalog-sort="' + map_url_param.sort + '"]')
                if ( element_sort == null ) {
                    catalog_container.querySelectorAll($RADIO_ALL + '[data-catalog-sort="featured"]').checked = true;
                } else {
                    element_sort.checked = true;
                }

                if ( urlQuery == '' ) {
                    // Set Default Card Feature
                    if ( card_feature_default.length > 0 ) {
                        card_feature_default[0].classList.add('show');
                    }
                    return;
                }

                for (let key in map_url_param) {
                    if ( map_url_param[key] == [] || key == 'sort' ) { continue; }
                    const toRemoveFromQueryParams = [];

                    map_url_param[key].forEach(attribute => {
                        let element = catalog_container.querySelector($CHECKBOX_ALL + '[data-category="' + key + '"][value="' + attribute + '"]');
                        if ( element != null ) {
                            element.checked = true;
                        } else {
                            toRemoveFromQueryParams.push(attribute);
                        }
                    });

                    map_url_param[key] = map_url_param[key].filter(attribute => !toRemoveFromQueryParams.includes(attribute));
                }

                collection_grid.update('url');

                if ( help_param ) {
                    whenAvailable('bootstrap', function() {
                        setTimeout(function() {
                            help_param.click();
                        }, 1000);
                    });
                }

                collection_grid.update('checkbox_nested');
            }

            // Remove color filter if there are no relevant products.
            function init_filter_color() {
                catalog_container.querySelectorAll($CHECKBOX_ALL + '[data-category="color"]').forEach(element => {
                    let color = element.value;
                    if ( catalog_container.querySelectorAll($CARD + '[data-color*="' + color + '"]').length == 0 ) {
                        element.parentElement.parentElement.remove();
                    }
                });
            }

            function thousand_sep(value) {
                return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }

            init_card_data();
            init_price_list();
            init_url_param();
            init_filter_color();
            add_product_color_options();
        }
    }
    new collection_grid();
})();


function getAvailableSizeTextBySaleSize(sizesToCheck, productSizes) {
    const allSizes = productSizes.map(size => {
        if (size === 'small') {
            return 'S';
        } else if (size === 'regular') {
            return 'R';
        } else if (size === 'xl') {
            return 'XL';
        }
    });

    if (sizesToCheck.length === 1 && allSizes.length === 3) {
        const filterSizes = allSizes.filter(size => !sizesToCheck.includes(size));
        return localeChairCollection?.for_certain_size_plural.replace("#firstSize", filterSizes[0]).replace("#secondSize", filterSizes[1])
    } else if (sizesToCheck.length === 1 && allSizes.length === 2) {
        const filterSizes = allSizes.filter(size => !sizesToCheck.includes(size));
        return localeChairCollection?.for_certain_size.replace("#certainSize", filterSizes[0])
    }

    return '';
}   